import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Divider } from '@hopskipdrive/react-components';

import { colorPalette } from '../../../shared/components/variables';
import { RidesActionBars } from '../../components/RidesActionBar';
import { RidesTabs } from '../../components/RidesTabs/RidesTabs';
import { useRidesTabs } from '../../hooks/useRidesTabs';

import { RidesHeader } from './RidesHeader';

export const RidesViewsLayout: FC = () => {
  const { selectedTab, handleTabChange, isRemovedRidersRoute, ...tabContext } = useRidesTabs();
  const outletContext = { ...tabContext, selectedTab };

  return (
    <>
      {isRemovedRidersRoute ? <RidesActionBars /> : <RidesHeader />}
      <Divider bgColor={colorPalette.neutralVariant90} opacity={0.5} />
      <RidesTabs value={selectedTab} onChange={handleTabChange} />
      <Outlet context={outletContext} />
    </>
  );
};
